<template>
	<div class="checkInQuery">
    <!-- 固定栏 -->
    <div class="fixed-content">
      <!-- tabBtn -->
      <div class="tabBtn">
        <mt-navbar class="navBar" v-model="selected">
          <mt-tab-item class="tabBtnNav1" id="1">学院入住查询</mt-tab-item>
          <mt-tab-item class="tabBtnNav1" id="2">进出记录</mt-tab-item>
          <mt-tab-item class="tabBtnNav1" id="3">个人查询</mt-tab-item>
        </mt-navbar>
      </div>

      <!-- tab-container -->
      <div class="margin-top-10">
        <mt-tab-container v-model="selected">
          <mt-tab-container-item id="1">
            <!-- 楼栋 年级 性别 入住个数 -->
            <div class="grid bg-e6e6e6">
              <div class="gridWarp nopadding noborder">
                <div class="gridCell flex-1">
                  <div class="dropdownBox">
                    <div id="building" class="dropdown font-size-14px">{{buildingData.name}}</div>
                  </div>  
                </div>
                <div class="gridCell flex-1">
                  <div class="dropdownBox">
                    <div id="grade" class="dropdown font-size-14px">{{gradeData.name}}</div>
                  </div>
                </div>
                <div class="gridCell flex-1">
                  <div class="dropdownBox">
                    <div id="gender" class="dropdown font-size-14px">{{genderData.name}}</div>
                  </div>
                </div>
                <div class="gridCell flex-1">
                  <div class="dropdownBox">
                    <div id="peopleNumber" class="dropdown font-size-14px">{{peopleNumberData.name}}</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 文字说明 -->
            <div class="bg-appStyle color-fff padding-lr-20 padding-tb-20" style="line-height: 18px;border-top: 1px solid #fff;border-bottom: 1px solid #fff;">
              <p class="font-size-14px">{{allMesCnt.title}}</p>
              <!-- <div class="dropdownBox">
                <div id="college" class="dropdown font-size-14px">{{collegeData.name}}</div>
              </div>   -->
              <p class="font-size-14px">人数合计:{{allMesCnt.personCnt}}人,男生:{{allMesCnt.personManCnt}}人,女生:{{allMesCnt.personWomanCnt}}人</p>
              <!-- <p class="font-size-14px">房间合计:{{allMesCnt.roomCnt}}间,男生房间:{{allMesCnt.roomManCnt}}间,女生房间:{{allMesCnt.roomWomanCnt}}间</p>
              <p class="font-size-14px">空床位合计:{{allMesCnt.emptyBedCnt}},男寝空床位:{{allMesCnt.emptyBedManCnt}},女寝空床位:{{allMesCnt.emptyBedWomanCnt}}</p> -->
            </div>
          </mt-tab-container-item>

          <mt-tab-container-item id="2">
            <!-- 搜索框 -->
            <div class="serachInput bg-fff">
              <div style="align-self: center;">
                <div class="font-size-14px" @click="selectData(1)" >{{pickerValue1new || '开始时间'}}</div>
                <mt-datetime-picker ref="picker1" type="date" :startDate="startDate" :endDate="endDate" v-model="selectedValue1" @confirm="handleConfirm1"></mt-datetime-picker>
              </div>
              
              <div class="margin-left-20" style="align-self: center;">
                <div class="font-size-14px" @click="selectData(2)">{{pickerValue2new || '结束时间'}}</div>
                <mt-datetime-picker ref="picker2" type="date" :startDate="startDate" :endDate="endDate" v-model="selectedValue2" @confirm="handleConfirm2"></mt-datetime-picker>
              </div>
              
              
              <div class="serach bg-f5f5f5">
                <input class="bg-f5f5f5 font-size-28" type="text" placeholder="输入姓名／学号" v-model="searchValue">
                <img class="deleteBtn" @click="deletInput()" src="static/images/searchDelete.png" />
                <div class="serachBtn color-fff margin-left-20 font-size-14px" @click="searchClick()">搜索</div>
              </div>
            </div>
          </mt-tab-container-item>

          <mt-tab-container-item id="3">
            <!-- 搜索框 -->
            <div class="serachInput bg-fff">
              <div class="serach bg-f5f5f5" style="width: 100%;">
                <input class="bg-f5f5f5 font-size-28" type="text" placeholder="输入姓名／学号" v-model="searchValue" style="width: 100%;">
                <img class="deleteBtn" @click="deletInput()" src="static/images/searchDelete.png" />
                <div class="serachBtn serachBtn1 color-fff margin-left-20 font-size-14px" @click="searchClick()">搜索</div>
              </div>
            </div>
          </mt-tab-container-item>
        </mt-tab-container>
      </div>

    </div>

    <!-- 内容栏 -->
    <!-- <div> -->
      <div v-if="selected == 1" class="scroll-content scroll-content1">
        <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" ref="loadmore" :auto-fill="false">
        <div class="grid bg-appStyle color-fff">
          <div class="gridWarp nopadding noborder">
            <div class="gridCell flex-basis-60">
              房间
            </div>
            <div class="gridCell flex-1">
              床位1
            </div>
            <div class="gridCell flex-1">
              床位2
            </div>
            <div class="gridCell flex-1">
              床位3
            </div>
            <div class="gridCell flex-1">
              床位4
            </div>
          </div>
        </div>
        <div class="tabContent">
          <div class="noData" v-if="list.length == 0">
              <div style="padding-bottom: 7rem;">
                  <img src="static/images/default-null.png"  alt="">
                  <p>暂时无相关数据</p>
              </div>
          </div>
          <div class="grid" v-if="list.length > 0">
            <div class="gridWarp" v-for="(item, index) in list" :key="index">
              <div class="gridCell flex-basis-60">
                <div v-html="item.roomNameJc"></div>
              </div>
              <!-- <div class="gridCell flex-1">
                <div v-if="item.studenet1Name">{{item.studenet1Name}}</div>
                <div v-if="item.studenet1Name">{{item.studenet1No}}</div>
                <div v-if="!item.studenet1Name">空床</div>
              </div>
              <div class="gridCell flex-1">
                <div v-if="item.studenet2Name">{{item.studenet2Name}}</div>
                <div v-if="item.studenet2Name">{{item.studenet2No}}</div>
                <div v-if="!item.studenet2Name">空床</div>
              </div>
              <div class="gridCell flex-1">
                <div v-if="item.studenet3Name">{{item.studenet3Name}}</div>
                <div v-if="item.studenet3Name">{{item.studenet3No}}</div>
                <div v-if="!item.studenet3Name">空床</div>
              </div>
              <div class="gridCell flex-1">
                <div v-if="item.studenet4Name">{{item.studenet4Name}}</div>
                <div v-if="item.studenet4Name">{{item.studenet4No}}</div>
                <div v-if="!item.studenet4Name">空床</div>
              </div> -->
              <div class="gridCell flex-1">
                <div v-if="item.studenet1Name" v-html="item.studenet1Name" :class="{'color-appStyle': item.studenet1Name == '已占用'}"></div>
                <div v-if="item.studenet1Name" v-html="item.studenet1No"></div>
                <div v-if="!item.studenet1Name" class="color-green">空床</div>
              </div>
              <div class="gridCell flex-1">
                <div v-if="item.studenet2Name" v-html="item.studenet2Name" :class="{'color-appStyle': item.studenet2Name == '已占用'}"></div>
                <div v-if="item.studenet2Name" v-html="item.studenet2No"></div>
                <div v-if="!item.studenet2Name" class="color-green">空床</div>
              </div>
              <div class="gridCell flex-1">
                <div v-if="item.studenet3Name" v-html="item.studenet3Name" :class="{'color-appStyle': item.studenet3Name == '已占用'}"></div>
                <div v-if="item.studenet3Name" v-html="item.studenet3No"></div>
                <div v-if="!item.studenet3Name" class="color-green">空床</div>
              </div>
              <div class="gridCell flex-1">
                <div v-if="item.studenet4Name" v-html="item.studenet4Name" :class="{'color-appStyle': item.studenet4Name == '已占用'}"></div>
                <div v-if="item.studenet4Name" v-html="item.studenet4No"></div>
                <div v-if="!item.studenet4Name" class="color-green">空床</div>
              </div>
              
            </div>
          </div>
        </div>
        </mt-loadmore>
      </div>
      <div v-if="selected == 2" class="scroll-content scroll-content2">
        <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" ref="loadmore" :auto-fill="false">
        <div class="noData" v-if="list.length == 0">
            <div style="padding-bottom: 7rem;">
                <img src="static/images/default-null.png"  alt="">
                <p>暂时无相关数据</p>
            </div>
        </div>
        <div class="listBox padding-20 border-bottom bg-fff" v-for="(item, index) in list" :key="index">
          <img class="thumbnail" :src="Url + item.facePhotoUrl">
          <div class="mesList">
            <div class="title color-333 font-size-14px">{{item.studentName}}
              <span class="label" :class="{'bg-f9b625': item.inOutFlag == 2, 'bg-appStyle': item.inOutFlag == 1}">{{item.inOutFlagName}}</span>
            </div>
            <p class="color-666 font-size-26 margin-top-8">{{item.studentNo}}</p>
            <p class="color-666 font-size-26 margin-top-8">{{item.roomName}}</p>
            <p class="color-666 font-size-26 margin-top-8">{{item.actionTime}}</p>
          </div>
        </div>
        </mt-loadmore>
      </div>
      <div v-if="selected == 3" class="scroll-content scroll-content3">
        <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" ref="loadmore" :auto-fill="false">
          <div class="noData" v-if="list.length == 0">
              <div style="padding-bottom: 7rem;">
                  <img src="static/images/default-null.png"  alt="">
                  <p>暂时无相关数据</p>
              </div>
          </div>
          <div class="listBox padding-20 border-bottom bg-fff" v-for="(item, index) in list" :key="index">
            <img class="thumbnail" :src="Url + item.faceUrl">
            <div class="mesList">
              <div class="title color-333 font-size-14px">姓名：{{item.name}}</div>
              <p class="color-666 font-size-26 margin-top-8">学号：{{item.studentNo}}</p>
              <p class="color-666 font-size-26 margin-top-8">学院：{{item.college}}</p>
              <p class="color-666 font-size-26 margin-top-8">当前年级：{{item.classYear}}</p>
              <p class="color-666 font-size-26 margin-top-8">房间号：{{item.roomName}}</p>
            </div>
          </div>
        </mt-loadmore>
      </div>
      
    </div>

	<!-- </div> -->
</template>

<script>

import Vue from 'vue'
import { mapGetters } from "vuex";
import { Navbar, TabItem } from 'mint-ui';
import { Loadmore } from 'mint-ui';
import { InfiniteScroll } from 'mint-ui';
import MobileSelect from 'mobile-select';
import { DatetimePicker } from 'mint-ui';
import { Toast } from 'mint-ui';

import {formatDateMin} from '@/util/filter'
import {beforeformatDate} from '@/util/filter'

import service from "@/fetch/service";
import * as types from '@/vuex/types';
Vue.component(DatetimePicker.name, DatetimePicker)
export default {
  components: {
    Navbar,
    TabItem,
    DatetimePicker
  },
  data() {
    return {
      startDate: new Date(),
      endDate: new Date(new Date().getTime() + (86400000*2)),
      Url: types.URL,
      searchValue: '', //搜索框值
      oldSearchValue: '', //搜索框值old
      selected: '1', //默认当前的tab 页面
      pageNo: 1, //分页
      pageSize: 20, //每次请求的个数
      allLoaded: true,//是否加载完毕
      haveMore: true, //是否有更多数据
      pickerValue1: beforeformatDate(7),
      pickerValue1new: '',
      pickerValue2: formatDateMin(new Date()),
      pickerValue2new: '',
      selectedValue1: '',
      selectedValue2: '',
      buildingDataArr: [
        {
          id: '',
          value: '选择楼栋'
        }
      ],
      buildingData: { //当前下拉框的值
        name: '选择楼栋',
        value: ''
      },
      gradeDataArr: [
        {
          id: '',
          value: '选择年级'
        }
      ],
      gradeData: { //当前下拉框的值
        name: '选择年级',
        value: ''
      },
      genderDataArr: [
        {
          id: '',
          value: '选择性别'
        },
        {
          id: '1',
          value: '男'
        },
        {
          id: '2',
          value: '女'
        }
      ],
      genderData: { //当前下拉框的值
        name: '选择性别',
        value: ''
      },
      peopleNumberDataArr: [
        {
          id: '',
          value: '选择人数'
        },
        {
          id: '1',
          value: '1'
        },
        {
          id: '2',
          value: '2'
        },
        {
          id: '3',
          value: '3'
        },
        {
          id: '4',
          value: '4'
        }
      ],
      peopleNumberData: { //当前下拉框的值
        name: '选择人数',
        value: ''
      },
      collegeDataArr: [], //学院选择
      collegeData: { //学院当前下拉框的值
        name: '选择学院',
        value: ''
      },
      allMesCnt: {}, //合计信息
      list: [] //数据
    };
  },
  created() {
    this.pickerValue1new = String(this.pickerValue1).slice(2);
    this.pickerValue2new = String(this.pickerValue2).slice(2);

    //获取 学院入住查询初始化页面查询
    this.collegeQueryInit();
    this.loaddata();
  },
  computed: {
    ...mapGetters([])
  },
  mounted() {},
  watch: {
    'selected': function() {
      this.list = [];
      this.searchValue = '';
      this.loadTop();
    }
  },
  methods: {
    selectData(type) { // 打开时间选择器
    console.log("打开时间选择器")
    console.log(type)
      
    // 如果已经选过日期，则再次打开时间选择器时，日期回显（不需要回显的话可以去掉 这个判断）
    if (type == 1) { //开始时间
      if (this.pickerValue1) {
        this.selectedValue1 = this.pickerValue1
      }else {
        this.selectedValue1 = new Date()
      }
      this.$refs['picker1'].open()
    }
    if (type == 2) { //结束时间
      if (this.pickerValue2) {
        this.selectedValue2 = this.pickerValue2
      }else {
        this.selectedValue2 = new Date()
      }
      this.$refs['picker2'].open()
    }
      
    },
    handleConfirm1() { // 时间选择器确定按钮，并把时间转换成我们需要的时间格式
      this.pickerValue1 = formatDateMin(this.selectedValue1)
      this.pickerValue1new = String(this.pickerValue1).slice(2);
      this.loadTop();
    },
    handleConfirm2() { // 时间选择器确定按钮，并把时间转换成我们需要的时间格式
      this.pickerValue2 = formatDateMin(this.selectedValue2)
      this.pickerValue2new = String(this.pickerValue2).slice(2);
      this.loadTop();
    },
    //一行只能显示4个字 多余的换行
    lineFourText: function (str, num) {
      if (!str) return ''
      let newStr = ''
      for (let index = 0; index < str.length; index++) {
        newStr += str[index]
        if ((index + 1) % num == 0) {
          newStr += '<br />'
        }
      }
      return newStr
    },
    //清除input里面的值
    deletInput: function () {
      if (!this.searchValue) {
        return
      }
      this.searchValue = '';
      this.loadTop();
    },
    //搜索按钮
    searchClick: function () {
      if (this.oldSearchValue != this.searchValue) {
        this.loadTop();
      }
    },
    //获取年级
    collegeQueryInit: function () {
      var that = this
      service
      .collegeQueryInit({})
      .then(res => {
        console.log(res);
        if (res.success) {
          res.result.areaVoList.forEach(element => {
            this.buildingDataArr.push({
              id: element.id,
              value: element.name
            })
          });
          res.result.gradeList.forEach(element => {
            this.gradeDataArr.push({
              id: element,
              value: element
            })
          });
          var mobileSelect1 = new MobileSelect({
              trigger: "#building",
              title: "请选择楼栋",
              wheels: [
                {data: that.buildingDataArr}
              ],
              callback:function(indexArr, data){
                  console.log(data);
                  that.buildingData = {
                    name: data[0].value,
                    value: data[0].id
                  }
                  that.loadTop();
              }
          });
          var mobileSelect2 = new MobileSelect({
              trigger: "#grade",
              title: "请选择年级",
              wheels: [
                {data: that.gradeDataArr}
              ],
              callback:function(indexArr, data){
                  console.log(data);
                  that.gradeData = {
                    name: data[0].value,
                    value: data[0].id
                  }
                  that.loadTop();
              }
          });
          var mobileSelect3 = new MobileSelect({
              trigger: "#gender",
              title: "请选择性别",
              wheels: [
                {data: that.genderDataArr}
              ],
              callback:function(indexArr, data){
                  console.log(data);
                  that.genderData = {
                    name: data[0].value,
                    value: data[0].id
                  }
                  that.loadTop();
              }
          });
          var mobileSelect4 = new MobileSelect({
              trigger: "#peopleNumber",
              title: "请选择人数",
              wheels: [
                {data: that.peopleNumberDataArr}
              ],
              callback:function(indexArr, data){
                  console.log(data);
                  that.peopleNumberData = {
                    name: data[0].value,
                    value: data[0].id
                  }
                  that.loadTop();
              }
          });

        }
      })
      .catch(error => {
        console.log(error);
      });
    },
    loadBottom: function(){//上拉加载更多
      console.log("上拉加载更多");
      this.more();                 
      this.$refs.loadmore.onBottomLoaded();
    },
    loadTop: function(){//下拉刷新
      this.pageNo =1;
      this.loaddata();               
      this.$refs.loadmore.onTopLoaded();
    },
    more() {
      // 分页查询
      this.pageNo++;
      this.loaddata();
    },
    loaddata(){ //加载数据从vuex中拿数据

      if (this.selected == 1) {
        this.getDatas1();
      }
      if (this.selected == 2) {
        this.getDatas2();
      }
      if (this.selected == 3) {
        this.getDatas3();
      }

    },
    getDatas1() {
      this.$store.dispatch("setLoadingState", true);
      service
      .findInRoomByCollegeList({
        "dormAreaId": this.buildingData.value, //楼栋id,默认查全部传null
        "classYear": this.gradeData.value, //年级，默认查全部传null
        "sex": this.genderData.value, //性别[1男生 2女生]，默认查全部传null
        "studentCnt":  this.peopleNumberData.value, //人数，1，2，3，4 默认查全部传null
        "page": this.pageNo,
        "limit": this.pageSize
      })
      .then(res => {
        console.log(res);
        this.$store.dispatch("setLoadingState", false);
        let result = res.result;
        console.log(this.allLoaded);
        if (res.success) {

          let listArr = result.list1VoPageInfo.rows;
          listArr.forEach(element => {
            element.roomName = this.lineFourText(element.roomName, 4)
            
            // element.studenet1Name = this.lineFourText(element.studenet1Name,6)
            element.studenet1Name = element.studenet1Name.slice(0,4)
            element.studenet1No = this.lineFourText(element.studenet1No,8)

            // element.studenet2Name = this.lineFourText(element.studenet2Name,6)
            element.studenet2Name = element.studenet2Name.slice(0,4)
            element.studenet2No = this.lineFourText(element.studenet2No,8)

            // element.studenet3Name = this.lineFourText(element.studenet3Name,6)
            element.studenet3Name = element.studenet3Name.slice(0,4)
            element.studenet3No = this.lineFourText(element.studenet3No,8)

            // element.studenet4Name = this.lineFourText(element.studenet4Name,6)
            element.studenet4Name = element.studenet4Name.slice(0,4)
            element.studenet4No = this.lineFourText(element.studenet4No,8)
          });
          if (this.pageNo == 1) {
            this.list = listArr;
            this.allLoaded = result.list1VoPageInfo.isLastPage;
            
            this.allMesCnt.personCnt = result.personCnt; //人数合计
            this.allMesCnt.personManCnt = result.personManCnt; //男生人数
            this.allMesCnt.personWomanCnt = result.personWomanCnt; //女生人数
            this.allMesCnt.title = res.result.title; //学院/楼栋
          } else{
              this.list = this.list.concat(listArr);
              this.allLoaded = result.list1VoPageInfo.isLastPage;
          }
        }
        
      })
      .catch(error => {
        this.$store.dispatch("setLoadingState", false);
        console.log(error);
        Toast(error.data.msg);
      });
    },
    getDatas2() {
      this.$store.dispatch("setLoadingState", true);
      service
      .findInRoomByCollegeInOutRercods({
        "startTime": this.pickerValue1, //开始时间，含时分秒 默认当前时间-7天
        "endTime": this.pickerValue2, //开始时间，含时分秒 默认当前时间
        "name": this.searchValue, //姓名或学号
        "page": this.pageNo,
        "limit": this.pageSize
      })
      .then(res => {
        console.log(res);
        this.$store.dispatch("setLoadingState", false);
        let result = res.result;
        console.log(this.allLoaded);
        if (res.success) {
          let listArr = result.rows;

          if (this.pageNo == 1) {
            this.list = listArr;
            this.allLoaded = result.isLastPage;
          } else{
              this.list = this.list.concat(listArr);
              this.allLoaded = result.isLastPage;
          }
        }
        
      })
      .catch(error => {
        this.$store.dispatch("setLoadingState", false);
        console.log(error);
        Toast(error.data.msg);
      });
    },
    getDatas3() {
      this.$store.dispatch("setLoadingState", true);
      service
      .findInRoomQueryTjByCollege({
        "name": this.searchValue, //姓名或学号
        "page": this.pageNo,
        "limit": this.pageSize
      })
      .then(res => {
        console.log(res);
        this.$store.dispatch("setLoadingState", false);
        let result = res.result;
        console.log(this.allLoaded);
        if (res.success) {
          let listArr = result.rows;

          if (this.pageNo == 1) {
            this.list = listArr;
            this.allLoaded = result.isLastPage;
          } else{
              this.list = this.list.concat(listArr);
              this.allLoaded = result.isLastPage;
          }
        }
        
      })
      .catch(error => {
        this.$store.dispatch("setLoadingState", false);
        console.log(error);
        Toast(error.data.msg);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/function";
$serachInput-height: px2rem(100px);
$gridCell-height: px2rem(70px);
$mes-height: px2rem(120px);
$other-height: px2rem(180px);
$cutLine-height: px2rem(20px);

$content1Height: px2rem(295px);
$content2Height: px2rem(200px);
.font-size-14px {
  font-size: 14px !important;
}
.mint-tab-item-label {
  font-size: 14px !important;
}
.checkInQuery {
  .fixed-content {
    height: 100px !important;
  }
  .scroll-content1 {
    top: calc(#{$content1Height + $cutLine-height}) !important;
  }
  .scroll-content2 {
    top: calc(#{$content2Height}) !important;
  }
  .scroll-content3 {
    top: calc(#{$content2Height}) !important;
  }
}
.cut-line {
  height: $cutLine-height;
  background: #f5f5f5;
}
.serachInput {
  height: $serachInput-height;
  // position: relative;
  display: flex;
  justify-content: space-between;
  padding: 0 px2rem(20px);
  background: #fff;
  //下拉框
  .dropdownBox {
    display: flex;
    justify-content: center;
    align-items: center;
    .dropdown {
      width: px2rem(115px);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: center;
    }
  }
  .serach {
    height: 70%;
    margin-left: px2rem(25px);
    padding: 0 px2rem(10px);
    border-radius: px2rem(10px);
    display: flex;
    justify-content: center;
    // flex: 1;
    align-self: center;
    input {
      height: 100%;
      // flex: 1;
      width: px2rem(220px);
    }
    .deleteBtn {
      width: px2rem(35px);
      height: px2rem(35px);
      align-self: center;
    }
    .serachBtn {
      width: px2rem(80px);
      height: px2rem(50px);
      line-height: px2rem(50px);
      background: #03a9f4;
      align-self: center;
      border-radius: px2rem(10px);
      text-align: center;
    }
    .serachBtn1 {
      width: px2rem(200px);
    }
  }
}
.gridWarp {
    display: flex;
    padding: px2rem(20px) 0;
    border-bottom: 1px solid #ececec;
    .gridCell:last-child {
      border-right: none;
    }
    .gridCell {
      font-size: 13px;
      line-height: 18px;
      // flex: 1;
      text-align: center;
      // height: $gridCell-height;
      // line-height: $gridCell-height;
      p {
        color: #333;
        font-size: 13px;
      }
      div {
        font-size: 13px;
      }
    }
}
.flex-1 {
  flex: 1;
}
.flex-basis-60 {
  flex-basis: px2rem(110px) !important;
  padding: 0 px2rem(10px);
}
.checkInQuery .tabBtn .navBar .tabBtnNav1 {
  padding: px2rem(30px) 0 !important;
  font-size: 14px;
}
.mobileSelect .content .btnBar .cancel, 
.mobileSelect .content .btnBar .ensure {
  font-size: 14px;
}
.mint-loadmore-text {
  font-size: 14px;
}
.listBox {
  .bg-f9b625 {
    background: #f9b625;
  }
  display: flex;
  //缩略图
  .thumbnail {
      width: px2rem(136px);
      height: px2rem(136px);
      margin-right: px2rem(30px);
      border-radius: px2rem(5px);
  }
  //缩略图-长方形
  .thumbnail-max {
      width: px2rem(210px);
      height: px2rem(136px);
      margin-right: px2rem(26px);
      border-radius: px2rem(5px);
  }
  //基本信息栏
  .mesList {
      flex: 1;
      .title {
          display: flex;
          align-items: center;
          flex: 1;
          //列表 标签
          .label {
              flex: none;
              display: inline-block;
              padding: 0 px2rem(15px);
              height: px2rem(32px);
              line-height: px2rem(32px);
              color: #fff;
              border-radius: px2rem(3px);
              margin-right: px2rem(16px);
              margin-left: px2rem(20px);
              font-size: px2rem(22px);
          }
      }
      //标签靠右-标签
      .title-label-right {
          justify-content: space-between;
      }
      p {
          color: #666;
          font-size: px2rem(26px);
          margin-top: px2rem(25px);
      }
  }
}

</style>


// WEBPACK FOOTER //
// CheckInQuery.vue?69d7c952